// extracted by mini-css-extract-plugin
export var gif = "_gk-0";